import React, {useEffect, useRef, useReducer} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {verifyUser} from "../authRequests";
import {patientReducer, init} from "../additional_files/reducer";
import Layout from "../components/Layout";
import ChangePassword from "../components/ChangePassword";
import TFA from "../components/TFA";
import Preferences from "../components/Preference";
import LoginHistory from "../components/LoginHistory";
import {Box, Heading, VStack, SimpleGrid, Text, Divider} from "@chakra-ui/react";

export default function SecurityPage() {
  const {state} = useLocation();
  const navigate = useNavigate();
  const [dashState, dispatch] = useReducer(patientReducer, state, init);
  const loadedRef = useRef(null);

  useEffect(() => {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      <VStack
        ref={loadedRef}
        style={{opacity: 0}}
        flex={1}
        w="100%"
        overflow="auto"
        alignItems="stretch"
      >
        <Box w="100%" flex={1} px={{base: 4, md: 6}} py={5}>
          <Box mb={5}>
            <Heading fontSize="xl" fontWeight="600" color="#1a1f36">
              Security
            </Heading>
            <Text fontSize="13px" color="#6b7280" mt={1}>
              Manage your account security and notification preferences
            </Text>
          </Box>

          <SimpleGrid columns={{base: 1, lg: 2}} spacing={4} mb={4}>
            {/* Password */}
            <Box
              bg="white"
              borderWidth="1px"
              borderColor="gray.100"
              borderRadius="lg"
              p={5}
            >
              <Heading as="h3" fontSize="sm" fontWeight="600" mb={1} color="#1a1f36">
                Password
              </Heading>
              <Text fontSize="xs" color="#6b7280" mb={4}>
                Use a strong, unique password you don't reuse elsewhere.
              </Text>
              <ChangePassword dashState={dashState} dashDispatch={dispatch} />
            </Box>

            {/* Preferences — 2FA + Notifications combined */}
            <Box
              bg="white"
              borderWidth="1px"
              borderColor="gray.100"
              borderRadius="lg"
              p={5}
            >
              <Heading as="h3" fontSize="sm" fontWeight="600" mb={1} color="#1a1f36">
                Preferences
              </Heading>
              <Text fontSize="xs" color="#6b7280" mb={4}>
                Two-factor authentication and notification settings.
              </Text>
              <TFA dashState={dashState} dashDispatch={dispatch} />
              <Divider my={4} borderColor="gray.100" />
              <Preferences dashState={dashState} dashDispatch={dispatch} />
            </Box>
          </SimpleGrid>

          {/* Login activity — full width */}
          <Box
            bg="white"
            borderWidth="1px"
            borderColor="gray.100"
            borderRadius="lg"
            p={5}
          >
            <Heading as="h3" fontSize="sm" fontWeight="600" mb={1} color="#1a1f36">
              Login activity
            </Heading>
            <Text fontSize="xs" color="#6b7280" mb={4}>
              Review recent sign-ins to keep your account secure.
            </Text>
            <LoginHistory dashState={dashState} dashDispatch={dispatch} />
          </Box>
        </Box>
      </VStack>
    </Layout>
  );
}
